import React from 'react';
import { Link } from 'react-router';
import { makeStyles } from '@mui/styles';
import { Grid, Chip, Avatar } from '@mui/material';
import { withStyles } from '@mui/styles';
import MuiTableCell from '@mui/material/TableCell';
import MuiCard from '@mui/material/Card';

import ClientInfo from './Sections/ClientInfo';
import ClientDetails from './Sections/ClientDetails';
import AvailableCredits from './Sections/AvailableCredits';
import ClientStatus from './Sections/ClientStatus';
import AdvancedMDStatus from './Sections/AdvancedMDStatus';
import LeadInfo from './Sections/LeadInfo';
import { checkFeatureFlag } from '@/common/utils/featureFlags';
import PinnedNote from './Sections/PinnedNote';

export const OverviewStyles: any = makeStyles(() => ({
  headingText: {
    fontWeight: 700,
    fontSize: '1.25em',
    marginBottom: '10px'
  },
  headingButton: {
    fontWeight: 700,
    marginBottom: '10px',
    color: '#22a9f3',
    backgroundColor: 'transparent',
    border: 'none',
    padding: 0,
    margin: 0,
    fontSize: '1.25em',
    cursor: 'pointer',
    transition: 'color 0.3s',
    '&:hover': {
      color: '#76b9e9'
    }
  },
  bodyText: {
    fontSize: '14px'
  },
  icon: {
    transform: 'translateY(5px)'
  },
  missingIcon: {
    display: 'inline',
    verticalAlign: 'middle',
    marginLeft: '2px',
    marginBottom: '3px',
    height: 20
  },
  noBorder: {
    border: '1px solid #FFFFFF'
  },
  noBorderSpaced: {
    border: '1px solid #FFFFFF',
    borderCollapse: 'separate',
    borderSpacing: '0px 4px'
  },
  rowHeader: {
    display: 'block',
    fontWeight: 'bold'
  },
  rowText: {
    display: 'block'
  },
  restoreLogo: {
    width: '22px',
    height: '22px'
  },
  birthdayIcon: {
    fontSize: '1rem',
    verticalAlign: 'middle',
    marginBottom: '4px',
    marginLeft: '3px'
  },
  email: {
    textDecoration: 'none'
  },
  wellnessPlanLink: {
    fontSize: '14px',
    cursor: 'pointer',
    color: '#3ba9f4',
    textDecoration: 'underline',
    marginTop: '5px'
  }
}));

export const OverviewTableCell = withStyles({
  root: {
    border: '1px solid #FFFFFF',
    paddingTop: '2px',
    paddingBottom: '2px',
    paddingLeft: '0px'
  }
})(MuiTableCell);

export const OverviewCard = withStyles({
  root: {
    padding: '16px'
  }
})(MuiCard);

const Info = props => {
  const { customerAllData: customerData, changeTab, drawerMode } = props;
  const note = customerData?.pinnedNote?.note;
  return (
    <Grid container spacing={3}>
      {!drawerMode && (
        <Grid item xs={12} display="flex" justifyContent="flex-end">
          <Link to={`/customer/edit/${customerData?.customer?.id}`}>
            <Chip
              clickable
              color="primary"
              label="Edit Client"
              avatar={<Avatar>+</Avatar>}
            />
          </Link>
        </Grid>
      )}
      <Grid item xs={8}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ClientInfo customerData={customerData} />
          </Grid>
          <Grid item xs={12}>
            <ClientDetails customerData={customerData} changeTab={changeTab} />
          </Grid>
          <Grid item xs={12}>
            <AvailableCredits
              customerData={customerData}
              changeTab={changeTab}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={4}>
        <Grid container spacing={3}>
          {note && (
            <Grid item xs={12}>
              <PinnedNote note={note} changeTab={changeTab} />
            </Grid>
          )}
          <Grid item xs={12}>
            <ClientStatus customerData={customerData} />
          </Grid>
          {checkFeatureFlag('PATIENT_LINKING') && (
            <Grid item xs={12}>
              <AdvancedMDStatus
                customerData={customerData}
                changeTab={changeTab}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <LeadInfo customerData={customerData} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default React.memo(Info);
